/* eslint-disable max-len */
import axios from 'axios';
import { errorInteractions } from '../../analytics';
import { setDropzoneCSSVars, setStackLayoutCSSVars } from './utils';

const transformProductInfo = (data, host) => {
  const {
    Attributes: {
      Matrix, MatrixSegments, DropzoneConfig, StackLayoutConfig,
      Scene7Folder, PackoutPipPersist, DisplayName, PortableStorageCallout
    },
    PartnerProductId, Brand, ProductName, GalleryImages,
    DraftProductLastUpdatedAt, IsDraft, ProductId
  } = data;

  const parsedSegments = MatrixSegments ? JSON.parse(MatrixSegments) : null;
  const parsedDropzones = DropzoneConfig ? JSON.parse(DropzoneConfig) : {};
  const parsedStackLayouts = StackLayoutConfig ? JSON.parse(StackLayoutConfig) : {};
  const [Rows, Columns] = Matrix.split(':') || [0, 0];
  const image = GalleryImages?.[0]?.ImageUrl?.split('SqlImages\\')[1];
  const visualizerImageUrl = `${host}/SqlImages/${image}`;

  // Set the page tab to the product name at site level
  document.title = ProductName;

  // Set the dropzone CSS variables
  setStackLayoutCSSVars(parsedStackLayouts);
  setDropzoneCSSVars(parsedDropzones);

  return {
    rows: Number(Rows),
    columns: Number(Columns),
    segments: parsedSegments.Segments,
    scene7Folder: Scene7Folder,
    visualizerImage: visualizerImageUrl,
    partnerProductId: PartnerProductId,
    brand: Brand,
    productName: ProductName,
    displayName: DisplayName,
    draftProductLastUpdated: DraftProductLastUpdatedAt,
    isDraft: IsDraft,
    packoutPipPersist: PackoutPipPersist === 'true',
    portableStorageCallout: PortableStorageCallout === 'True', // Attribute is boolean
    productId: ProductId
  };
};

export const getProductInfo = async (host, productId) => {
  try {
    const response = await axios.get(`${host}/api/v2/products/${productId}/site/11`);
    return transformProductInfo(response?.data, host);
  } catch (err) {
    const errorObject = {
      type: 'catastrophic',
      displayType: 'inline',
      pageSection: 'Get Product Info',
      message: err,
    };
    const trackErrorInteractions = { errorObject, primaryCategory: 'error', eventName: 'post page error' };
    errorInteractions(trackErrorInteractions);
    return null;
  }
};
